import React, { Component } from 'react';
import { searchAccount } from '../../actions/actionHelpers/endpoints';
import { AutoCompleteSelect } from '../';
import { translateLegalEntityTypeClassificator } from '../../utils/translateHelpers';

const getDataSource = async (value) => {
  const { data } = await searchAccount(value);
  return data.map((item) => {
    let label =
      item.companyName +
      ', ' +
      translateLegalEntityTypeClassificator(item.accountType);
    if (item.accountNumber) {
      label += ' [' + item.accountNumber + ']';
    }
    return { value: item.id, label };
  });
};

class AutoCompleteAccountsSelect extends Component {
  render() {
    return <AutoCompleteSelect {...this.props} getDataSource={getDataSource} />;
  }
}

export default AutoCompleteAccountsSelect;
